import { render, staticRenderFns } from "./Geofence.vue?vue&type=template&id=5defbea1"
import script from "./Geofence.vue?vue&type=script&lang=js"
export * from "./Geofence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports